import { ShelfTalkerMenu } from './shelf-talker-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class GlassHouseShelfTalkerMenu extends ShelfTalkerMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Inter.SemiBold_600, FONT.Inter.Bold_700, FONT.Inter.ExtraBold_800, FONT.Poppins.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/keq5tol.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  override variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
